import { handleHttpResponse } from '@arcxmoney/arcx-react'

export class ArcxApi {
  constructor(private arcxUrl: string) {}

  async getUserRewards() {
    return this.fetchFromApi('/rewards')
  }

  async getSkillSetsFor(userAddress: string, type: string) {
    return this.fetchFromApi(`/skillsets/${userAddress}/${type}`)
  }

  private async fetchFromApi(...[url, ...args]: Parameters<typeof fetch>) {
    return fetch(`${this.arcxUrl}${url}`, ...args).then(handleHttpResponse)
  }
}
